import React from "react";
import theme from "theme";
import { Theme, Link, Image, LinkBox, Box, Span, Text, Section, Input, Button, Em, Strong, Icon } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml, Override, Formspree } from "@quarkly/components";
import * as Components from "components";
import { MdEmail, MdLocationOn } from "react-icons/md";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"feedback"} />
		<Helmet>
			<title>
				Aid-vertise - Turning Ads into Aid
			</title>
			<meta name={"description"} content={"Aid-vertise transforms your browser into a solution that raises money for disability charities. With every new tab, you help fund social programs, post-secondary scholarships, and medical services for people with disabilities & developmental needs. "} />
			<meta property={"og:title"} content={"Aid-vertise - Turning Ads into Aid"} />
			<meta property={"og:description"} content={"Aid-vertise transforms your browser into a solution that raises money for disability charities. With every new tab, you help fund social programs, post-secondary scholarships, and medical services for people with disabilities & developmental needs. "} />
			<meta property={"og:image"} content={"https://uploads.quarkly.io/63a25993f63de40026725928/images/Group%2069.jpg?v=2024-01-06T18:39:53.403Z"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/63a25993f63de40026725928/images/Group%2024.png?v=2023-03-05T21:23:37.784Z"} type={"image/x-icon"} />
			<link rel={"apple-touch-icon"} href={"https://uploads.quarkly.io/63a25993f63de40026725928/images/Group%2024%20%281%29.jpg?v=2024-01-06T18:29:44.221Z"} />
			<link rel={"apple-touch-icon"} sizes={"76x76"} href={"https://uploads.quarkly.io/63a25993f63de40026725928/images/Group%2024%20%281%29.jpg?v=2024-01-06T18:29:44.221Z"} />
			<link rel={"apple-touch-icon"} sizes={"152x152"} href={"https://uploads.quarkly.io/63a25993f63de40026725928/images/Group%2024%20%281%29.jpg?v=2024-01-06T18:29:44.221Z"} />
			<link rel={"apple-touch-startup-image"} href={"https://uploads.quarkly.io/63a25993f63de40026725928/images/Group%2024%20%281%29.jpg?v=2024-01-06T18:29:44.221Z"} />
			<meta name={"msapplication-TileImage"} content={"https://uploads.quarkly.io/63a25993f63de40026725928/images/Group%2024%20%281%29.jpg?v=2024-01-06T18:29:44.221Z"} />
			<meta name={"msapplication-TileColor"} content={"#ffffff"} />
		</Helmet>
		<Section background="#ffffff" position="relative" box-shadow="0 .7px 1px 0px rgba(55, 65, 81, 0.1)">
			<Override slot="SectionContent" />
			<Box min-width="100px" min-height="50px">
				<LinkBox display="block" width="200px" href="/index">
					<Image
						src="https://uploads.quarkly.io/63a25993f63de40026725928/images/Group%2022.png?v=2024-01-02T23:15:06.973Z"
						display="block"
						height="35px"
						srcSet="https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2022.png?v=2024-01-02T23%3A15%3A06.973Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2022.png?v=2024-01-02T23%3A15%3A06.973Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2022.png?v=2024-01-02T23%3A15%3A06.973Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2022.png?v=2024-01-02T23%3A15%3A06.973Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2022.png?v=2024-01-02T23%3A15%3A06.973Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2022.png?v=2024-01-02T23%3A15%3A06.973Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2022.png?v=2024-01-02T23%3A15%3A06.973Z&quality=85&w=3200 3200w"
						sizes="(max-width: 460px) 100vw,(max-width: 767px) 100vw,(max-width: 992px) 100vw,100vw"
					/>
				</LinkBox>
			</Box>
			<LinkBox
				height="Auto"
				display="block"
				width="80px"
				margin="30px 0px 0px 0px"
				pointer-events="auto"
				href="/index"
			>
				<Text
					margin="0px 0px 0px 0px"
					color="rgba(55, 65, 81, 0.7)"
					font="400 10px/20px --fontFamily-googlePoppins"
					width="80px"
					hover-transform="translateX(-10px)"
					hover-color="#374151"
					transition="all .3s ease-in-out 0s"
				>
					<Span
						font-size="16px"
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						← Home
					</Span>
				</Text>
			</LinkBox>
			<Box
				min-width="100px"
				min-height="80px"
				display="flex"
				align-items="center"
				justify-content="flex-start"
				margin="0px 0px 0px 0px"
			>
				<Text
					margin="0px 0px 0px 0px"
					font="normal 600 50px/1 --fontFamily-googlePoppins"
					color="--dark"
					text-align="left"
					sm-font="normal 600 35px/1.4 --fontFamily-googlePoppins"
					lg-font="normal 600 45px/1.1 --fontFamily-googlePoppins"
					md-font="normal 600 35px/1 --fontFamily-googlePoppins"
					sm-margin="15px 0px 0px 0px"
				>
					We'd love to hear from you!
				</Text>
			</Box>
		</Section>
		<Components.FeedbackForm />
		<Section
			padding="60px 0 40px 0"
			md-padding="40px 0 40px 0"
			id="footer"
			sm-background="#ffffff"
			background="#ffffff"
		>
			<Override slot="SectionContent" flex-direction="column" md-flex-wrap="wrap" md-flex-direction="column" />
			<Box min-width="100px" min-height="100px" display="flex" md-flex-direction="column">
				<Box
					md-max-width="100%"
					sm-padding="24px 12px 36px 12px"
					width="60%"
					border-width="1px"
					border-color="#e2e3e6"
					border-radius="5px"
					border-style="solid"
					padding="20px 48px 20px 48px"
					md-width="100%"
				>
					<Text
						as="h3"
						font="normal 400 30px/1.2 --fontFamily-googlePoppins"
						sm-padding="0px 8px 0px 8px"
						sm-margin="0 0 8px 0"
						color="--darkL2"
						sm-font="normal 400 20px/1.2 --fontFamily-googleInter"
					>
						Get in Touch
					</Text>
					<Formspree
						endpoint="xbjerwee"
						errorMessage="Something went wrong. Please try again."
						completeText="Sent! We'll be in contact shortly."
						color="#ffffff"
						font="500 20px/24px --fontFamily-googleInter"
					>
						<Box gap="16px" display="flex" flex-direction="row" flex-wrap="wrap">
							<Box width="100%" display="flex" flex-direction="column" padding="8px 8px 8px 0px">
								<Input
									width="100%"
									name="name"
									type="text"
									placeholder="Name"
									required
								/>
							</Box>
							<Box padding="8px 8px 8px 0px" width="100%" display="flex" flex-direction="column">
								<Input
									width="100%"
									type="email"
									name="email"
									placeholder="Email"
									required
								/>
							</Box>
							<Box padding="8px 8px 8px 0px" width="100%" display="flex" flex-direction="column">
								<Input
									as="textarea"
									rows="4"
									width="100%"
									name="message"
									placeholder="Message"
									required
								/>
							</Box>
							<Box
								padding="8px 8px 8px 8px"
								width="100%"
								display="flex"
								flex-direction="column"
								align-items="flex-end"
							>
								<Button
									background="rgba(254, 170, 204, 0)"
									border-width="1px"
									border-style="solid"
									border-color="#cbd5e1"
									color="--indigo"
									href="mailto:aidvertize@gmail.com?Customer Message"
									type="submit"
									hover-color="--indigo"
									border-radius="5px"
									hover-background="rgba(131, 54, 255, 0.07)"
									focus-box-shadow="0 0 0 0px --color-indigo"
									focus-border-color="--color-indigo"
									hover-border-color="--color-indigo"
									transition="all .3s ease 0s"
								>
									Send
								</Button>
							</Box>
						</Box>
					</Formspree>
				</Box>
				<Box
					min-width="100px"
					min-height="100px"
					width="40%"
					display="flex"
					flex-direction="row"
					md-width="100%"
				>
					<Box
						empty-border-color="LightGray"
						flex-direction="column"
						display="flex"
						padding="16px 16px 0px 16px"
						md-width="100%"
						empty-min-width="64px"
						empty-min-height="64px"
						empty-border-width="1px"
						empty-border-style="solid"
						margin="0px 0px 0px 30px"
						md-margin="0px 0px 0px 0px"
						sm-padding="16px 0px 16px 0px"
						width="100%"
						lg-padding="0px 16px 0px 16px"
					>
						<Box
							min-width="100px"
							min-height="50px"
							md-display="flex"
							sm-flex-direction="column"
							md-flex-direction="column"
							md-margin="30px 0px 20px 0px"
							lg-display="flex"
							lg-flex-direction="column"
							lg-justify-content="flex-start"
							lg-margin="0px 0px 30px 0px"
							margin="0px 0px 40px 0px"
							sm-margin="30px 0px 30px 0px"
						>
							<Text
								as="h4"
								margin="6px 0"
								font="--base"
								sm-width="100%"
								color="--darkL2"
							>
								<Strong
									overflow-wrap="normal"
									word-break="normal"
									white-space="normal"
									text-indent="0"
									text-overflow="clip"
									hyphens="manual"
									user-select="auto"
									pointer-events="auto"
								>
									Explore Aid-
									<Em>
										vertise
									</Em>
								</Strong>
							</Text>
							<Box
								min-width="100px"
								min-height="40px"
								md-display="flex"
								md-min-height="50px"
								lg-min-height="50px"
								sm-flex-direction="row"
								display="flex"
								flex-direction="row"
								lg-flex-direction="column"
								md-flex-direction="row"
							>
								<LinkBox
									text-align="left"
									align-items="flex-start"
									href="/index#home"
									md-width="50%"
									md-margin="0px 0px 0px 0px"
									sm-margin="7px 0px 7px 0px"
									width="50%"
									lg-width="100%"
									lg-margin="0px 0px 10px 0px"
								>
									<Text
										as="p"
										font="normal 400 14px/1.6 --fontFamily-googleInter"
										sm-width="100%"
										color="rgba(55, 65, 81, 0.7)"
										margin="0px 0px 0px 0px"
										sm-color="rgba(55, 65, 81, 0.7)"
										border-color="rgba(55, 65, 81, 0.7)"
										hover-color="#374151"
										transition="all .3s ease-in-out 0s"
									>
										Home
									</Text>
								</LinkBox>
								<LinkBox
									text-align="left"
									align-items="flex-start"
									href="/index#download"
									md-width="50%"
									md-margin="0px 0px 0px 0px"
									sm-margin="7px 0px 7px 0px"
									transition="--transformInOut"
									width="50%"
									lg-width="100%"
									lg-margin="0px 0px 10px 0px"
								>
									<Text
										as="p"
										font="normal 400 14px/1.6 --fontFamily-googleInter"
										sm-width="100%"
										color="rgba(55, 65, 81, 0.7)"
										margin="0px 0px 0px 0px"
										sm-color="rgba(55, 65, 81, 0.7)"
										hover-color="#374151"
										transition="all .3s ease-in-out 0s"
									>
										Download
									</Text>
								</LinkBox>
							</Box>
							<Box
								min-width="100px"
								min-height="40px"
								md-display="flex"
								md-min-height="50px"
								lg-min-height="50px"
								sm-flex-direction="row"
								display="flex"
								flex-direction="row"
								lg-flex-direction="column"
								md-flex-direction="row"
							>
								<LinkBox
									text-align="left"
									align-items="flex-start"
									href="/turning-off-adblock"
									md-width="50%"
									md-margin="0px 0px 0px 0px"
									sm-margin="7px 0px 7px 0px"
									width="50%"
									lg-width="100%"
									lg-margin="0px 0px 10px 0px"
								>
									<Text
										as="p"
										font="normal 400 14px/1.6 --fontFamily-googleInter"
										sm-width="100%"
										color="rgba(55, 65, 81, 0.7)"
										margin="0px 0px 0px 0px"
										sm-color="rgba(55, 65, 81, 0.7)"
										border-color="rgba(55, 65, 81, 0.7)"
										hover-color="#374151"
										transition="all .3s ease-in-out 0s"
									>
										Turning off Adblock
									</Text>
								</LinkBox>
								<LinkBox
									text-align="left"
									align-items="flex-start"
									href="/feedback"
									md-width="50%"
									md-margin="0px 0px 0px 0px"
									sm-margin="7px 0px 7px 0px"
									transition="--transformInOut"
									width="50%"
									lg-width="100%"
									lg-margin="0px 0px 10px 0px"
								>
									<Text
										as="p"
										font="normal 400 14px/1.6 --fontFamily-googleInter"
										sm-width="100%"
										color="rgba(55, 65, 81, 0.7)"
										margin="0px 0px 0px 0px"
										sm-color="rgba(55, 65, 81, 0.7)"
										hover-color="#374151"
										transition="all .3s ease-in-out 0s"
									>
										Share Feedback
									</Text>
								</LinkBox>
							</Box>
							<Box
								min-width="100px"
								min-height="40px"
								md-display="flex"
								md-min-height="50px"
								lg-min-height="50px"
								sm-flex-direction="row"
								display="flex"
								flex-direction="row"
								lg-flex-direction="column"
								md-flex-direction="row"
							>
								<LinkBox
									text-align="left"
									align-items="flex-start"
									href="https://docs.google.com/document/d/1ACP719Mx-jX_lFS3Uu6NA2EgcFmtzOJgbiWfjQrpiUQ/edit?usp=sharing"
									md-width="50%"
									md-margin="0px 0px 0px 0px"
									sm-margin="7px 0px 7px 0px"
									width="50%"
									lg-width="100%"
									lg-margin="0px 0px 10px 0px"
									target="_blank"
								>
									<Text
										as="p"
										font="normal 400 14px/1.6 --fontFamily-googleInter"
										sm-width="100%"
										color="rgba(55, 65, 81, 0.7)"
										margin="0px 0px 0px 0px"
										sm-color="rgba(55, 65, 81, 0.7)"
										border-color="rgba(55, 65, 81, 0.7)"
										hover-color="#374151"
										transition="all .3s ease-in-out 0s"
									>
										Privacy Policy
									</Text>
								</LinkBox>
								<LinkBox
									text-align="left"
									align-items="flex-start"
									href="https://docs.google.com/document/d/1JofT-rkrrPI8JosmsvttYE2Ymv549wEHgUX65Fi2Fh8/edit"
									md-width="50%"
									md-margin="0px 0px 0px 0px"
									sm-margin="7px 0px 7px 0px"
									transition="--transformInOut"
									width="50%"
									lg-width="100%"
									lg-margin="0px 0px 10px 0px"
									target="_blank"
								>
									<Text
										as="p"
										font="normal 400 14px/1.6 --fontFamily-googleInter"
										sm-width="100%"
										color="rgba(55, 65, 81, 0.7)"
										margin="0px 0px 0px 0px"
										sm-color="rgba(55, 65, 81, 0.7)"
										hover-color="#374151"
										transition="all .3s ease-in-out 0s"
									>
										Terms of Service
									</Text>
								</LinkBox>
							</Box>
						</Box>
						<Box display="flex" md-margin="20px 0px 0px 0px" sm-align-items="center" sm-justify-content="center">
							<Image
								height="auto"
								src="https://uploads.quarkly.io/63a25993f63de40026725928/images/Group%2022.png?v=2024-01-02T23:15:06.973Z"
								max-width="171px"
								margin="0px 0px 0px 5px"
								sm-width="100%"
								srcSet="https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2022.png?v=2024-01-02T23%3A15%3A06.973Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2022.png?v=2024-01-02T23%3A15%3A06.973Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2022.png?v=2024-01-02T23%3A15%3A06.973Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2022.png?v=2024-01-02T23%3A15%3A06.973Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2022.png?v=2024-01-02T23%3A15%3A06.973Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2022.png?v=2024-01-02T23%3A15%3A06.973Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2022.png?v=2024-01-02T23%3A15%3A06.973Z&quality=85&w=3200 3200w"
								sizes="(max-width: 460px) 100vw,(max-width: 767px) 100vw,(max-width: 992px) 100vw,100vw"
							/>
						</Box>
						<Box min-width="100px" min-height="100px" md-display="flex" sm-flex-direction="column">
							<Box
								padding="0 0 0 64px"
								sm-padding="40px 0 0 0"
								margin="20px 0 0 0"
								max-width="360px"
								position="relative"
								sm-display="flex"
								sm-width="100%"
								sm-max-width="100%"
								sm-margin="20px 0 0 0"
								sm-flex-direction="column"
							>
								<Icon
									position="absolute"
									size="30px"
									top="0"
									left="0"
									category="md"
									icon={MdEmail}
									color="--indigo"
									width="40px"
									height="40px"
									sm-width="30px"
								/>
								<Text
									as="h4"
									margin="6px 0"
									font="normal 400 18px/1.5 --fontFamily-googleInter"
									sm-width="100%"
									color="--dark"
									border-color="--color-dark"
								>
									Contact Us
								</Text>
								<Text
									as="p"
									margin="6px 0"
									font="normal 400 18px/1.6 --fontFamily-googleInter"
									sm-width="100%"
									color="--blue"
								>
									aidvertise.team@gmail.com
								</Text>
							</Box>
							<Box
								padding="0 0 0 64px"
								sm-padding="40px 0 0 0"
								margin="20px 0 0 0"
								max-width="360px"
								position="relative"
								sm-display="flex"
								sm-flex-direction="column"
								sm-width="100%"
								sm-max-width="100%"
								md-margin="32px 0 0 30px"
								sm-margin="30px 0 0 0px"
							>
								<Icon
									position="absolute"
									size="30px"
									top="0"
									left="0"
									category="md"
									icon={MdLocationOn}
									color="--indigo"
									width="40px"
									height="40px"
									sm-width="30px"
								/>
								<Text
									as="h4"
									margin="6px 0"
									font="--base"
									sm-width="100%"
									color="--darkL2"
								>
									Headquarters
								</Text>
								<Text
									as="p"
									margin="6px 0"
									font="normal 400 18px/1.6 --fontFamily-googleInter"
									sm-width="100%"
									color="--blue"
								>
									Toronto, Canada
								</Text>
							</Box>
						</Box>
					</Box>
				</Box>
			</Box>
			<Text color="--darkL2" font="700 13px/24px --fontFamily-googleInter" margin="20px 0px 0px 0px" border-color="--color-darkL2">
				<Span font-weight="normal">
					© Aid-vertise. All Rights Reserved.
				</Span>
			</Text>
		</Section>
		<Link
			font={"--capture"}
			font-size={"10px"}
			position={"fixed"}
			bottom={"12px"}
			right={"12px"}
			z-index={"4"}
			border-radius={"4px"}
			padding={"5px 12px 4px"}
			background-color={"--dark"}
			opacity={"0.6"}
			hover-opacity={"1"}
			color={"--light"}
			cursor={"pointer"}
			transition={"--opacityOut"}
			quarkly-title={"Badge"}
			text-decoration-line={"initial"}
			href={"https://quarkly.io/"}
			target={"_blank"}
		>
			Made on Quarkly
		</Link>
		<RawHtml>
			<style place={"endOfHead"} rawKey={"6123949e957019001e284456"}>
				{":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\na[href=\"https://quarkly.io/\"]{\ndisplay: none;\n}"}
			</style>
			<style place={"endOfBody"} rawKey={"63ab46a125e1dd39903991f6"}>
				{"a[href=\"https://quarkly.io/\"]{\ndisplay: none;\n}"}
			</style>
			<meta
				charset={""}
				name={"theme-color"}
				content={"white"}
				http-equiv={""}
				place={"endOfHead"}
				rawKey={"63ab6040713fa2b8da76759a"}
			/>
			<script place={"endOfHead"} rawKey={"63d4a2ee3c792adefb43bfac"}>
				{"window.onscroll = function() {changeelementstyle()};\nfunction changeelementstyle() {\n  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {\n\t\tdocument.getElementById(\"navbar\").style.boxShadow = \"0 4px 6px 0 rgba(0,0,0,.2)\";\n\t\t\n  } else {\n\t\tdocument.getElementById(\"navbar\").style.boxShadow = \"0 0 0 0 rgba(0,0,0,.2)\";\n\t}\n}\n\nfunction openRightMenu() {\n\tdocument.getElementById(\"rightMenu\").style.display = \"block\";\n}\n\nfunction closeRightMenu() {\n  document.getElementById(\"rightMenu\").style.display = \"none\";\n}\n\nwindow.onload = function () {\n changeelementstyle()\n};"}
			</script>
			<style place={"endOfHead"} rawKey={"63d4a308d9f278c1afd3278b"}>
				{"#navbar {\n  background-color: white;\n  position: fixed;\n  display: flex;\n  transition: padding 0.4s, box-shadow .5s;\n  width: 100%;\n}\n\n#navbar a {\n  display: block;\n  text-align: center;\n  padding: 10px 0px 10px 0px;\n  font-size: 14px;\n}\n\n.contactnav{\n    float:right;     \n    display: block;\n    width: 180px;\n    height: 45px;\n    background: #8336ff;\n    text-align: center;\n    border-radius: 5px;\n    color: white;\n    font-weight: 500;\n    line-height: 25px;\n    font-family: \"Inter\", sans-serif;\n    margin-top: 5px;\n    transition: color 0.3s; \n}\n\n.contactnav:hover {\n  background-color: #6608ff;\n}\n\n.NFTnav {\n    float:right;     \n    display: block;\n    width: 150px;\n    height: 45px;\n    text-align: center;\n    border-radius: 5px;\n    color: #8336ff;\n    line-height: 25px;\n    margin-left: 20px;\n    margin-right: 15px;\n    margin-top: 5px;\n    font-weight: 600;\n    font-family: \"Inter\", sans-serif;\n    border-style: solid;\n    border-width: .8px;\n    border-color: #cbd5e1;\n    margin-bottom: 10px;\n    transition: color 0.3s; \n}\n\n.NFTnav:hover {\n  background: #f7f1ff;\n  border-color: #8336ff;\n  border-width: 1px;\n}\n\n#logo { \n  display: flex; \n  height: 35px;\n  transition: height 0.4s;\n}\n\n#logoside {  \n  height: 35px;\n  margin-bottom:20px;\n  margin-left:20px;\n}\n\n#hamburgermenu {\n  transition: padding 0.4s;\n  float:right;\n}\n\n#Contactnav, #nFTnav {\n  transition: border-color 0.6s, margin-top 0.4s, background-color 0.3s;\n  float:right;\n}\n\n#navbar a.active {\n  background-color: white;\n  color: white;\n}\n\n#navbar .Hamburgermenu {\n  display: none;\n}\n\n#rightMenu{\n  display:none;\n  position:fixed;\n  width:100%;\n  z-index:1000;\n  float:right;     \n  background: white;\n  width: 200px;\n  height: 100%;\n  box-shadow:0 0 0 10000px rgba(0,0,0,.50);\n  visibility: hidden;\n  font-size: 20px;\n  animation: animateright 0.4s\n}\n\n.bar-item{\n  font-weight: 450;\n  padding:8px 15px;\n  float:left;\n  width:100%;\n  border:none;\n  display:inline-block;\n  outline:0;\n  vertical-align:middle;\n  color:inherit;\n  background-color:inherit; \n  text-align:left;\n  overflow:hidden;\n  white-space:nowrap;\n}\n.closeout{\n  padding:8px 15px;\n  float:left;\n  width:100%;\n  border:none;\n  display:inline-block;\n  outline:0;\n  vertical-align:middle;\n  color:inherit;\n  background-color:inherit; \n  text-align:left;\n  overflow:hidden;\n  white-space:nowrap;\n}\n.bar-item:hover{\n  background-color: rgba(131, 54, 255, 0.07);\n}\n\n.activeside{\n  position: absolute;\n  left: 0;\n  bottom: 0;\n}\n\n.centernavbar {\n    display: flex;\n    align-items: left;\n    justify-content: left;\n    font-weight: 450;\n\n}\n\n.centernavbarobjects{\n  margin-right: 30px;\n  font-family: 'Inter', sans-serif;\n  transition: padding 0.4s, color 0.3s;\n  color:  #5f6367;\n  display: inline-block;\n  position: relative;\n  height:100%;\n}\n\n@keyframes animateright{from{right:-300px;opacity:0} to{right:0;opacity:1}}\n\n@media screen and (max-width: 1180px) {\n  #navbar a:not(.active) {display: none;}\n  #navbar a.Hamburgermenu {\n    float: right;\n    display: block;\n  }\n  #rightMenu{\n    visibility: visible;\n  }\n\n}\n\n\n@media screen and (max-width: 400px) {\n  #navbar a:not(.active) {display: none;}\n  #navbar a.Hamburgermenu {\n    float: right;\n    display: block;\n  }\n  #rightMenu{\n    visibility: visible;\n  }\n#logo{\nmargin-top: 10px;\nheight: 25px;\n}\n\n}\n\n\n\n\na:link, a:visited, a:hover {\n  text-decoration:none;\n}\n"}
			</style>
			<script place={"endOfHead"} rawKey={"63d6f9c1eb319ed27ac6a558"}>
				{"window.onload = function () {\n\n// Cache selectors\nvar lastId,\n topMenu = $(\"#mainNav\"),\n topMenuHeight = topMenu.outerHeight()+1,\n // All list items\n menuItems = topMenu.find(\"a\"),\n // Anchors corresponding to menu items\n scrollItems = menuItems.map(function(){\n   var item = $($(this).attr(\"href\"));\n    if (item.length) { return item; }\n });\n\n// Bind click handler to menu items\n// so we can get a fancy scroll animation\nmenuItems.click(function(e){\n  var href = $(this).attr(\"href\"),\n      offsetTop = href === \"#\" ? 0 : $(href).offset().top-topMenuHeight+1;\n  $('html, body').stop().animate({ \n      scrollTop: offsetTop\n  }, 0);\n  e.preventDefault();\n});\n\n// Bind to scroll\n$(window).scroll(function(){\n   // Get container scroll position\n   var fromTop = $(this).scrollTop()+topMenuHeight;\n   \n   // Get id of current scroll item\n   var cur = scrollItems.map(function(){\n     if ($(this).offset().top < fromTop)\n       return this;\n   });\n   // Get the id of the current element\n   cur = cur[cur.length-1];\n   var id = cur && cur.length ? cur[0].id : \"\";\n   \n   if (lastId !== id) {\n       lastId = id;\n       // Set/remove active class\n       menuItems\n         .parent().removeClass(\"active\")\n         .end().filter(\"[href=#\"+id+\"]\").parent().addClass(\"active\");\n   }                   \n});\n\n\n};\n"}
			</script>
			<style place={"endOfHead"} rawKey={"63d6f9e43e25829bfe037297"}>
				{"ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  position: relative;\n  display: table;\n  margin: 0 auto;\n}\nul li {\n  display: table-cell;\n}\nul li a {\n  display: block;\n  color: white;\n  text-decoration: none;\n}\nul li a:hover {\n  color: #374151;\n}\n\nul .active a {\n  color: #374151;\n  border-bottom: 3px solid #8336ff;\n}\n\nsection {\n  position: relative;\n  margin: 0;\n  padding: 0;\n  display: block;\n  z-index: 0;\n}\n"}
			</style>
			<script src={"https://cdnjs.cloudflare.com/ajax/libs/jquery/2.1.3/jquery.min.js"} place={"endOfHead"} rawKey={"63d6fa336fc98c1d91fb0e00"} />
			<script src={""} place={"endOfBody"} rawKey={"668b118571f710d414da79f9"} />
			<script async={true} src={""} place={"endOfHead"} rawKey={"668b12f46970d1e4fc5a2cea"}>
				{"<!-- Google tag (gtag.js) -->\n<script async src=\"https://www.googletagmanager.com/gtag/js?id=G-SQL2FMVEYW\"></script>\n<script>\n  window.dataLayer = window.dataLayer || [];\n  function gtag(){dataLayer.push(arguments);}\n  gtag('js', new Date());\n\n  gtag('config', 'G-SQL2FMVEYW');\n</script>"}
			</script>
		</RawHtml>
	</Theme>;
});